(() => {
  const scrollers = document.querySelectorAll('.business-cases');

  scrollers.forEach((scroller) => {
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    const stopDragging = () => {
      isDragging = false;
      scroller.classList.remove('is-dragging');
    };

    scroller.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch') return;

      isDragging = true;
      startX = event.clientX;
      scrollLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
      scroller.setPointerCapture(event.pointerId);
    });

    scroller.addEventListener('pointermove', (event) => {
      if (!isDragging) return;

      event.preventDefault();
      scroller.scrollLeft = scrollLeft - (event.clientX - startX);
    });

    scroller.addEventListener('pointerup', stopDragging);
    scroller.addEventListener('pointercancel', stopDragging);
    scroller.addEventListener('pointerleave', stopDragging);
  });
})();
